import { Select, Typography } from "antd";
import { SortFieldRowProps } from "./types";

const { Text } = Typography;

const SORT_DIRECTIONS = [
  { value: "ascending", label: "Ascending" },
  { value: "descending", label: "Descending" },
];

export const SortFieldRow = ({
  fieldName,
  selectedDirection,
  onChange,
  columnsTitleCreator,
}: SortFieldRowProps) => (
  <div
    data-testid={`sort-group-${fieldName}`}
    className="flex items-center gap-2 w-full"
  >
    <div className="flex-1 min-w-0">
      <div className="flex h-8 p-[5px_8px] items-center rounded-[4px] border border-[#0000001f]">
        <Text ellipsis={{ tooltip: true }} className="w-full text-[#2B4752]">
          {columnsTitleCreator(fieldName)}
        </Text>
      </div>
    </div>
    <div className="flex-1 min-w-0">
      <div data-testid={`sorting-direction-${fieldName}`}>
        <Select
          options={SORT_DIRECTIONS}
          placeholder="None"
          value={selectedDirection}
          onChange={onChange}
          className="w-full"
          classNames={{ root: "sort-select", popup: { root: "sort-popup" } }}
        />
      </div>
    </div>
  </div>
);
